import React from 'react'

const Support = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0)
  },[])
  return (
    <div className='app'>Support</div>
  )
}

export default Support